/*=====================================
    ProductView

    Author: Ac
    CreateTime: 2018 / 11 / 06
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, {
    PureComponent,
} from 'react';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import ProductContentView from 'components/product/ProductContentView';
import NewProductsSideBarView from 'components/newproducts/commons/NewProductsSideBarView';
import { connect } from 'react-redux';
import CupoyRouter from 'components/commons/router/CupoyRouter';

/*--------------------------
    Styled
--------------------------*/
const Container = styled.div`
    display: grid;
    grid-gap: ${GlobalStyle.ViewSpace}px;
    grid-template-columns: 1fr 244px;
    grid-template-rows: auto auto;
    align-items: flex-start;
`;
/*--------------------------
    Main Component
--------------------------*/
class ProductView extends PureComponent {

    constructor(props) {
        super(props);

        const routerState = CupoyRouter.getCurrent();
        const { params } = routerState;
        const { id: productid } = params;

        this.state = {
            productid,
        };
    }

    componentDidUpdate(prevProps, prevState) {

        const routerState = CupoyRouter.getCurrent();
        const { params } = routerState;
        const { id: productid } = params;

        if (productid !== prevState.productid) {
            this.setState({
                productid,
            });
        }
    }

    render() {
        return (
            <GlobalStyle.SubContainer>
                <Container>
                    <ProductContentView productid={this.state.productid}  />
                    <NewProductsSideBarView />
                </Container>
            </GlobalStyle.SubContainer>
        );
    }
};

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        history: state.web.history,
    };
};

/*--------------------------
Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
    };
};

/*--------------------------
export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps)(ProductView);
  